import { useFormik } from "formik";
import { useState } from "react";
import { useLocation } from "react-router-dom";
import * as yup from "yup";
import { useTranslation } from "../../i18n";
import { availableRoutes } from "../../router/routes";
import { Authentication } from "../../services/authentication";
import { SuccessCodeRegex } from "../../services/fetch-util";

export const useResetPasswordForm = () => {
  const { t } = useTranslation(["resetPassword"]);
  const [serverErrors, setServerErrors] = useState("");
  const location = useLocation();
  const ResetPasswordSchema = yup.object().shape({
    newPassword: yup
      .string()
      .min(8, t("resetPassword:min"))
      .max(32, t("resetPassword:max"))
      .matches(/^(?=.*[a-z])/, t("resetPassword:oneLowercase"))
      .matches(/^(?=.*[A-Z])/, t("resetPassword:oneUppercase"))
      .matches(/^(?=.*[0-9])/, t("resetPassword:oneNumber"))
      .matches(/^(?=.*[!@#\$%\^\&*\\(\)_+\-=\\{\}\\[\]\\\|;:’,.\?\/`~><])/, t("resetPassword:oneSpecial"))
      .required(t("resetPassword:newPasswordrequired")),
    confirmNewPassword: yup
      .string()
      .oneOf([yup.ref("newPassword")], t("resetPassword:match"))
      .required(t("resetPassword:confirmNewPasswordrequired"))
  });
  const formik = useFormik({
    initialValues: { newPassword: "", confirmNewPassword: "" },
    validationSchema: ResetPasswordSchema,
    onSubmit: async values => {
      const searchParams = new URLSearchParams(location.search);
      const response = await Authentication.setNewPassword(searchParams.get("code") || "", {
        password: values.confirmNewPassword
      });
      if (response?.status.toString().match(SuccessCodeRegex)) {
        const login = await Authentication.login({
          username: searchParams.get("username") || "",
          password: values.confirmNewPassword
        });
        if (login?.status.toString().match(SuccessCodeRegex)) {
          window.location.href = availableRoutes.default;
        } else {
          setServerErrors(t("resetPassword:loginError"));
        }
      } else {
        switch (response?.status) {
          case 400:
            setServerErrors(response?.parsedBody?.message || "");
            break;

          case 401:
            setServerErrors(t("resetPassword:codeExpirationError"));
            break;
        }
      }
    }
  });
  return {
    ...formik,
    serverErrors
  };
};
